/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sessions: NonNullable<unknown>, duration: NonNullable<unknown> }} Wrapped_Cover_LineInputs */

const en_us2_wrapped_cover_line = /** @type {(inputs: Wrapped_Cover_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`One workout done, ${i?.duration} of training.`);
	return /** @type {LocalizedString} */ (`${i?.sessions} workouts done, ${i?.duration} of training.`)
	
};

const pt_br2_wrapped_cover_line = /** @type {(inputs: Wrapped_Cover_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`Um treino feito, com ${i?.duration} de treino.`);
	return /** @type {LocalizedString} */ (`${i?.sessions} treinos feitos, com ${i?.duration} de treino.`)
	
};

const es_419_wrapped_cover_line = /** @type {(inputs: Wrapped_Cover_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`Un entrenamiento hecho, ${i?.duration} de entrenamiento.`);
	return /** @type {LocalizedString} */ (`${i?.sessions} entrenamientos hechos, ${i?.duration} de entrenamiento.`)
	
};

const pt_pt2_wrapped_cover_line = /** @type {(inputs: Wrapped_Cover_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`Um treino feito, com ${i?.duration} de treino.`);
	return /** @type {LocalizedString} */ (`${i?.sessions} treinos feitos, com ${i?.duration} de treino.`)
	
};

const fr_fr2_wrapped_cover_line = /** @type {(inputs: Wrapped_Cover_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`Une séance faite, ${i?.duration} d'entraînement.`);
	return /** @type {LocalizedString} */ (`${i?.sessions} séances faites, ${i?.duration} d'entraînement.`)
	
};

const de_de2_wrapped_cover_line = /** @type {(inputs: Wrapped_Cover_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`Ein Training geschafft, ${i?.duration} Trainingszeit.`);
	return /** @type {LocalizedString} */ (`${i?.sessions} Trainings geschafft, ${i?.duration} Trainingszeit.`)
	
};

const it_it2_wrapped_cover_line = /** @type {(inputs: Wrapped_Cover_LineInputs) => LocalizedString} */ (i) => {
	if ((i?.sessions === 1 || i?.sessions === "1")) return /** @type {LocalizedString} */ (`Un allenamento fatto, ${i?.duration} di allenamento.`);
	return /** @type {LocalizedString} */ (`${i?.sessions} allenamenti fatti, ${i?.duration} di allenamento.`)
	
};

/**
* | sessions | output |
* | --- | --- |
* | "1" | "One workout done, {duration} of training." |
* | * | "{sessions} workouts done, {duration} of training." |
*
* @param {Wrapped_Cover_LineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_cover_line = /** @type {((inputs: Wrapped_Cover_LineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Cover_LineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_cover_line(inputs)
	if (locale === "es-419") return es_419_wrapped_cover_line(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_cover_line(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_cover_line(inputs)
	if (locale === "de-DE") return de_de2_wrapped_cover_line(inputs)
	if (locale === "it-IT") return it_it2_wrapped_cover_line(inputs)
	return en_us2_wrapped_cover_line(inputs)
});
export { wrapped_cover_line as "wrapped.cover_line" }